<!-- eslint-disable prettier/prettier -->
<template>
  <div class="container">
    <ContentLoader :is-loading="isLoadingSlots" class="ContentLoader">
      <div v-if="!hasSlots && !creatingSchedule">
        <CreateSchedule :open-form="openForm" />
      </div>

      <div class="schedule-settings" v-else-if="creatingSchedule && !hasSlots">
        <div class="schedule-form-grid">
          <!-- Coluna principal: 4 cards -->
          <div class="schedule-form-grid__main">
            <!-- Card 1: Dias da semana -->
            <div class="agenda-card">
              <p class="agenda-card__title">Dias da semana</p>
              <div class="radio-group">
                <label class="radio-option">
                  <input
                    v-model="scheduleDaysCode"
                    type="radio"
                    value="1"
                    name="scheduleDaysCode"
                  />
                  <span class="radio-option__label">Segunda à sexta</span>
                </label>
                <label class="radio-option">
                  <input
                    v-model="scheduleDaysCode"
                    type="radio"
                    value="2"
                    name="scheduleDaysCode"
                  />
                  <span class="radio-option__label">Todos os dias</span>
                </label>
                <label class="radio-option">
                  <input
                    v-model="scheduleDaysCode"
                    type="radio"
                    value="3"
                    name="scheduleDaysCode"
                  />
                  <span class="radio-option__label">Selecionar os dias</span>
                </label>
              </div>

              <div class="day-chips">
                <label
                  class="day-chip"
                  :class="{
                    'is-selected': work_days.includes('sunday'),
                    'is-disabled': dayIsSelectable
                  }"
                >
                  <input
                    type="checkbox"
                    value="sunday"
                    v-model="work_days"
                    :disabled="dayIsSelectable"
                  />
                  Dom
                </label>
                <label
                  class="day-chip"
                  :class="{
                    'is-selected': work_days.includes('monday'),
                    'is-disabled': dayIsSelectable
                  }"
                >
                  <input
                    type="checkbox"
                    value="monday"
                    v-model="work_days"
                    :disabled="dayIsSelectable"
                  />
                  Seg
                </label>
                <label
                  class="day-chip"
                  :class="{
                    'is-selected': work_days.includes('tuesday'),
                    'is-disabled': dayIsSelectable
                  }"
                >
                  <input
                    type="checkbox"
                    value="tuesday"
                    v-model="work_days"
                    :disabled="dayIsSelectable"
                  />
                  Ter
                </label>
                <label
                  class="day-chip"
                  :class="{
                    'is-selected': work_days.includes('wednesday'),
                    'is-disabled': dayIsSelectable
                  }"
                >
                  <input
                    type="checkbox"
                    value="wednesday"
                    v-model="work_days"
                    :disabled="dayIsSelectable"
                  />
                  Qua
                </label>
                <label
                  class="day-chip"
                  :class="{
                    'is-selected': work_days.includes('thursday'),
                    'is-disabled': dayIsSelectable
                  }"
                >
                  <input
                    type="checkbox"
                    value="thursday"
                    v-model="work_days"
                    :disabled="dayIsSelectable"
                  />
                  Qui
                </label>
                <label
                  class="day-chip notranslate"
                  :class="{
                    'is-selected': work_days.includes('friday'),
                    'is-disabled': dayIsSelectable
                  }"
                >
                  <input
                    type="checkbox"
                    value="friday"
                    v-model="work_days"
                    :disabled="dayIsSelectable"
                  />
                  Sex
                </label>
                <label
                  class="day-chip"
                  :class="{
                    'is-selected': work_days.includes('saturday'),
                    'is-disabled': dayIsSelectable
                  }"
                >
                  <input
                    type="checkbox"
                    value="saturday"
                    v-model="work_days"
                    :disabled="dayIsSelectable"
                  />
                  Sáb
                </label>
              </div>
            </div>

            <!-- Card 2: Período -->
            <div class="agenda-card">
              <p class="agenda-card__title">Período de vigência</p>
              <div class="date-row">
                <div>
                  <p class="date-row__label notranslate">De</p>
                  <div class="datepick-wrapper">
                    <DatePick
                      v-model="slot_config.from_date"
                      next-month-caption="Próximo mês"
                      prev-month-caption="Mês anterior"
                      :weekdays="weekdays.default()"
                      :months="months.default()"
                      :start-week-on-sunday="true"
                      :is-date-disabled="isPastDate"
                      :format="'YYYY-MM-DD'"
                      :display-format="'DD/MM/YYYY'"
                    />
                  </div>
                </div>
                <div>
                  <p class="date-row__label notranslate">Até</p>
                  <div class="datepick-wrapper">
                    <DatePick
                      v-model="slot_config.until_date"
                      next-month-caption="Próximo mês"
                      prev-month-caption="Mês anterior"
                      :weekdays="weekdays.default()"
                      :months="months.default()"
                      :start-week-on-sunday="true"
                      :is-date-disabled="isPastDate"
                      :format="'YYYY-MM-DD'"
                      :display-format="'DD/MM/YYYY'"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 3: Duração -->
            <div class="agenda-card">
              <p class="agenda-card__title">Duração da consulta</p>
              <div class="radio-group">
                <label class="radio-option">
                  <input
                    type="radio"
                    value="1"
                    name="duration_type"
                    v-model="duration_type"
                  />
                  <span class="radio-option__label">
                    Usar o tempo padrão (15 min)
                  </span>
                </label>
                <label class="radio-option">
                  <input
                    type="radio"
                    value="2"
                    name="duration_type"
                    v-model="duration_type"
                  />
                  <span class="radio-option__label">
                    Personalizar manualmente
                  </span>
                </label>
              </div>
              <div class="duration-select-row">
                <select
                  :disabled="disableDurationSelection"
                  v-model="slot_config.duration"
                  class="select"
                  :class="{ 'select--disabled': disableDurationSelection }"
                >
                  <option
                    v-for="duration in durations"
                    :key="duration"
                    :selected="duration === slot_config.duration"
                    :value="duration"
                  >
                    {{ duration }} min
                  </option>
                </select>
                <p class="duration-select-row__hint">
                  Serão {{ slot_config.duration }} minutos para cada paciente.
                </p>
              </div>
            </div>

            <!-- Card 4: Horários -->
            <div class="agenda-card">
              <p class="agenda-card__title">Horários de atendimento</p>
              <div class="radio-group">
                <label class="radio-option">
                  <input
                    type="radio"
                    value="1"
                    name="serviceHoursType"
                    v-model="serviceHoursType"
                  />
                  <span class="radio-option__label">
                    O mesmo para todos os dias
                  </span>
                </label>
                <label class="radio-option">
                  <input
                    type="radio"
                    value="2"
                    name="serviceHoursType"
                    v-model="serviceHoursType"
                  />
                  <span class="radio-option__label">
                    Personalizar manualmente
                  </span>
                </label>
              </div>

              <div
                class="day-group"
                v-for="(dayOfWork, work_day_index) in sortedDays()"
                :key="work_day_index"
              >
                <p class="day-group__label">
                  {{ displaySelectedDays(dayOfWork) }}
                </p>

                <div
                  class="time-block"
                  v-for="(time, slot_index) in dayOfWork.times"
                  :key="slot_index"
                >
                  <select
                    :disabled="disableSlotOptions(work_day_index, slot_index)"
                    class="select"
                    :class="{
                      'select--error': !(
                        dayOfWork.times[slot_index].start_time &&
                        dayOfWork.times[slot_index].end_time
                      )
                    }"
                    v-model="
                      slot_config.work_days[work_day_index].times[slot_index]
                        .start_time
                    "
                    @change="updateListHours(work_day_index, slot_index)"
                  >
                    <option
                      v-for="hour in slot_config.work_days[work_day_index]
                        .times[slot_index].start_time_options"
                      :key="hour"
                      :selected="
                        hour ===
                          slot_config.work_days[work_day_index].times[
                            slot_index
                          ].start_time
                      "
                      :value="hour"
                    >
                      {{ hour }}
                    </option>
                  </select>

                  <span class="time-block__sep">→</span>

                  <select
                    :disabled="disableSlotOptions(work_day_index, slot_index)"
                    class="select"
                    :class="{
                      'select--error': !(
                        dayOfWork.times[slot_index].start_time &&
                        dayOfWork.times[slot_index].end_time
                      )
                    }"
                    v-model="
                      slot_config.work_days[work_day_index].times[slot_index]
                        .end_time
                    "
                    @change="updateListHours(work_day_index, slot_index)"
                  >
                    <option
                      v-for="hour in slot_config.work_days[work_day_index]
                        .times[slot_index].end_time_options"
                      :key="hour"
                      :selected="
                        hour ===
                          slot_config.work_days[work_day_index].times[
                            slot_index
                          ].end_time
                      "
                      :value="hour"
                    >
                      {{ hour }}
                    </option>
                  </select>

                  <span class="time-block__count">
                    {{ countAppointments(time) }} consulta(s)
                  </span>

                  <button
                    type="button"
                    class="time-block__remove"
                    :disabled="dayOfWork.times.length === 1"
                    @click.prevent="removeSlot(work_day_index, slot_index)"
                    aria-label="Remover horário"
                  >
                    <img src="./../../assets/images/trash-icon.svg" alt="" />
                  </button>

                  <p
                    class="time-block__error"
                    v-if="
                      !(
                        dayOfWork.times[slot_index].start_time &&
                        dayOfWork.times[slot_index].end_time
                      )
                    "
                  >
                    Preencha os campos de horário
                  </p>
                </div>

                <button
                  type="button"
                  class="add-slot-btn"
                  @click.prevent="addSlot(work_day_index)"
                  :disabled="disableAddSlotButton(work_day_index)"
                >
                  + Novo horário
                </button>
              </div>
            </div>
          </div>

          <!-- Resumo lateral -->
          <div class="summary-card">
            <p class="summary-card__title">Resumo</p>

            <div class="summary-row">
              <span class="summary-row__label">Dias</span>
              <span class="summary-row__value">
                <span v-for="(day, i) in selectedAndSortedDays" :key="i">
                  {{ translateDay(day.work_day) }}
                  <span v-if="i < selectedAndSortedDays.length - 1">,</span>
                </span>
                <span v-if="!selectedAndSortedDays.length">—</span>
              </span>
            </div>

            <hr class="divider" />

            <div class="summary-row">
              <span class="summary-row__label">Duração</span>
              <span class="summary-row__value">
                {{ slot_config.duration }} min
              </span>
            </div>

            <div class="summary-row" v-if="slot_config.from_date">
              <span class="summary-row__label">Início</span>
              <span class="summary-row__value">{{ startOfAppointments }}</span>
            </div>

            <div class="summary-row">
              <span class="summary-row__label">Horários</span>
              <span class="summary-row__value">
                <span
                  v-for="(config, ci) in sortedDaysOnScheduleReview"
                  :key="ci"
                >
                  <span v-if="dayByDaySelected" class="summary-day-label">
                    {{ translateDayOnScheduleReview(config.day_of_week) }}:
                  </span>
                  <span v-for="(slot, si) in config.times" :key="si">
                    {{ slot.start_time }}–{{ slot.end_time }}
                    <span v-if="si < config.times.length - 1">,</span>
                  </span>
                  <br v-if="ci < sortedDaysOnScheduleReview.length - 1" />
                </span>
              </span>
            </div>

            <hr class="divider" />

            <div class="summary-total">
              <span class="summary-total__label">Total estimado</span>
              <span class="summary-total__value">
                {{ countAllAppointments() }}
              </span>
              <span class="summary-total__sub">horários abertos</span>
            </div>

            <button
              class="btn btn--primary"
              :disabled="canSaveSlots"
              @click.prevent="saveSlot()"
            >
              Salvar configuração
            </button>
          </div>
        </div>
      </div>

      <div v-else>
        <ScheduleResume :doctor-id="doctorId" :unit-id="unitId" />
      </div>
    </ContentLoader>
  </div>
</template>

<script>
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import {
  parseISO,
  differenceInMinutes,
  addDays,
  format,
  eachDayOfInterval,
  isMonday,
  isSunday,
  isFriday,
  isSaturday,
  isThursday,
  isTuesday,
  isWednesday,
  getDay,
  addMinutes,
  endOfToday,
  startOfToday,
  setHours,
  setMinutes
} from "date-fns";
import dateFNS from "date-fns";
import { formatDate } from "./../../utils/masks/formatSlotDate";
import {
  slotMethods,
  userComputed,
  doctorMethods
} from "./../../state/helpers";
import ScheduleResume from "./../ScheduleResume";
import CreateSchedule from "./../CreateSchedule";
import ContentLoader from "../../components/ContentLoader.vue";
import { isReceptionist } from "../../utils/userRole";

export default {
  name: "ScheduleSettings",
  components: {
    DatePick,
    ScheduleResume,
    CreateSchedule,
    ContentLoader
  },
  data() {
    return {
      isLoadingSlots: true,
      slot_config: {
        from_date: "",
        until_date: "",
        duration: 15,
        work_days: [
          {
            hours: [],
            times: [{ start_time: "", end_time: "", interval: 0 }]
          }
        ]
      },
      hours: Array.from({ length: 24 }, (v, k) => {
        const h = k.toString();
        return h.length === 2 ? `${h}:00` : `0${h}:00`;
      }),
      intervalOptions: [5, 10, 15, 20, 25, 30],
      work_days: [],
      scheduleDaysCode: 1,
      duration_type: 1,
      durations: [15, 30, 45, 60, 90],
      serviceHoursType: 1,
      weekdays: {
        type: Array,
        default: () => ["SEG", "TER", "QUA", "QUI", "SEX", "SÁB", "DOM"]
      },
      months: {
        type: Array,
        default: () => [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ]
      },
      days: [
        { name: "sunday", translate: "Domingo", day_of_week: 0 },
        { name: "monday", translate: "Segunda", day_of_week: 1 },
        { name: "tuesday", translate: "Terça", day_of_week: 2 },
        { name: "wednesday", translate: "Quarta", day_of_week: 3 },
        { name: "thursday", translate: "Quinta", day_of_week: 4 },
        { name: "friday", translate: "Sexta", day_of_week: 5 },
        { name: "saturday", translate: "Sábado", day_of_week: 6 }
      ]
    };
  },
  mounted() {
    if (this.userGuide) {
      if (!this.hasSlots && !this.currentUser.address.id) {
        this.$router.push({ name: "GuidePage" });
      }
    }
    this.getDoctorAvailableSlots();

    if (this.userIsReceptionist) {
      this.getDoctorAvailableSlots(`unit_id=${this.$route.params.unitId}`);
    }

    this.work_days = ["monday", "tuesday", "wednesday", "thursday", "friday"];
    this.slot_config.from_date = format(addDays(new Date(), 1), "yyyy-MM-dd");
    this.noTranslateSomeWords();
  },
  beforeDestroy() {
    this.$store.commit("slot/SET_CREATING_SCHEDULE", false);
  },
  methods: {
    ...slotMethods,
    ...doctorMethods,
    isSunday,
    isMonday,
    isTuesday,
    isWednesday,
    isThursday,
    isFriday,
    isSaturday,
    getDoctorAvailableSlots(query) {
      this.isLoadingSlots = true;

      const payload = { id: this.doctorId };

      if (query) payload.query = query;

      this.fetchDoctorsAvailables(payload).then(response => {
        if (response.data.length) {
          this.$store.commit("slot/SET_HAS_SLOTS", true);
        } else {
          this.$store.commit("slot/SET_HAS_SLOTS", false);
        }

        this.isLoadingSlots = false;
      });
    },
    translateDay(day) {
      const index = this.days.findIndex(item => item.name === day);
      if (index > -1) return this.days[index].translate;
    },
    countAppointments(time) {
      const start_time = `2000-01-01 ${time.start_time}`;
      const end_time = `2000-01-01 ${time.end_time}`;
      const diffInMinutes = differenceInMinutes(
        parseISO(end_time),
        parseISO(start_time)
      );

      const appointmentDuration = this.slot_config.duration;
      const appointmentInterval = time.interval;
      const appointmentTotalTime = appointmentDuration + appointmentInterval;

      const count = Math.floor(diffInMinutes / appointmentTotalTime);
      return count < 0 ? 0 : count;
    },

    displaySelectedDays(dayOfWork) {
      if (this.serviceHoursType == 1 && this.slot_config.work_days.length == 1)
        return "Todos os dias";

      return this.days[dayOfWork.day_of_week].translate;
    },
    addSlot(work_day_index) {
      let day = this.slot_config.work_days[work_day_index];

      let newSlot = {
        start_time: "",
        end_time: "",
        interval: 0,
        start_time_options: this.buildArrayOfHours(),
        end_time_options: []
      };

      if (day.times.length >= 1) {
        newSlot.start_time_options = this.buildArrayOfHours(
          newSlot.interval,
          day.times[day.times.length - 1].end_time
        );
      }

      day.times.push(newSlot);
    },
    removeSlot(work_day_index, times_index) {
      this.slot_config.work_days[work_day_index].times.splice(times_index, 1);
    },
    fillWorkDays() {
      if (this.serviceHoursType == 1)
        return (this.slot_config.work_days = [
          {
            times: [
              {
                start_time: "",
                end_time: "",
                interval: 0,
                start_time_options: this.buildArrayOfHours(),
                end_time_options: []
              }
            ]
          }
        ]);

      this.work_days.filter((day, day_index) => {
        const day_of_week = this.getDayOfWeek(day_index);
        if (this.isInTheAppointmentDateInterval(day)) {
          const dayIsSelect = this.slot_config.work_days.some(
            work_day => work_day.day_of_week == day_of_week
          );

          if (!dayIsSelect) {
            this.slot_config.work_days.push({
              day_of_week,
              times: [
                {
                  start_time: "",
                  end_time: "",
                  interval: 0,
                  start_time_options: this.buildArrayOfHours(),
                  end_time_options: []
                }
              ]
            });
          } else {
          }
        } else {
          let indexToRemove = null;
          this.slot_config.work_days.filter((work_day, work_day_index) => {
            if (work_day.day_of_week == day_of_week)
              indexToRemove = work_day_index;
          });
          if (indexToRemove)
            this.slot_config.work_days.splice(indexToRemove, 1);
        }
      });

      this.slot_config.work_days.sort(this.sortDayByDayOfWeek());
    },
    loadHours(work_day_index, slot_index, key) {
      let day = this.slot_config.work_days[work_day_index];
      let slot = day.times[slot_index];
      let validateFrom = null;
      let options = [];

      if (day.times.length == 1) {
        slot.start_time_options = this.buildArrayOfHours(slot.interval);
        slot.end_time_options = slot.start_time
          ? this.buildArrayOfHours(slot.interval, slot.start_time)
          : [];
      } else {
        slot.start_time_options = this.buildArrayOfHours(
          slot.interval,
          day.times[slot_index - 1].end_time
        );
        slot.end_time_options = slot.start_time
          ? this.buildArrayOfHours(slot.interval, slot.start_time)
          : [];
      }
    },
    isPastDate(date) {
      const currentDate = new Date();
      return date < currentDate;
    },
    countAllAppointments() {
      let count = 0;
      let that = this;
      if (this.slot_config.from_date && this.slot_config.until_date) {
        this.appointmentsDateInterval.filter(date => {
          this.work_days.filter(day => {
            let whichDayIs = "is" + that.capitalizeFirstLetter(day);
            if (this[whichDayIs](date)) {
              this.slot_config.work_days.filter(work_day => {
                if (
                  (work_day.day_of_week &&
                    work_day.day_of_week == getDay(date)) ||
                  !work_day.day_of_week
                ) {
                  for (var i = work_day.times.length - 1; i >= 0; i--) {
                    count += this.countAppointments(work_day.times[i]);
                  }
                }
              });
            }
          });
        });
      }

      return count < 0 ? 0 : count;
    },
    translateDayOnScheduleReview(day_of_week) {
      const day = this.days.filter(day => day.day_of_week === day_of_week)[0];
      return day ? day.translate : "";
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getDayOfWeek(index) {
      let day_of_week = 0;

      this.days.filter((day, day_index) => {
        if (this.work_days[index] == day.name) day_of_week = day_index;
      });

      return day_of_week;
    },
    isInTheAppointmentDateInterval(day) {
      return this.appointmentsDateInterval.some(date => {
        let whichDayIs = "is" + this.capitalizeFirstLetter(day);
        return this[whichDayIs](date);
      });
    },
    buildArrayOfHours(interval = null, validator = null) {
      const appointmentTotalTime = (interval || 0) + this.slot_config.duration;
      let start = startOfToday();
      let end = endOfToday();
      let hours = [];

      if (validator) {
        start = setHours(start, parseInt(validator.split(":")[0]));
        start = setMinutes(start, parseInt(validator.split(":")[1]));
      } else {
        hours.push("00:00");
      }

      while (addMinutes(start, appointmentTotalTime) < end) {
        let nextHour = addMinutes(start, appointmentTotalTime);
        start = addMinutes(start, appointmentTotalTime);
        hours.push(format(nextHour, "HH:mm"));
      }
      return hours;
    },
    updateListHours(work_day_index, slot_index) {
      this.loadHours(work_day_index, slot_index);
    },
    disableSlotOptions(work_day_index, slot_index) {
      const day = this.slot_config.work_days[work_day_index];
      const slot = day.times[slot_index];
      return !!(
        slot.start_time &&
        slot.end_time &&
        day.times.length > slot_index + 1
      );
    },
    disableAddSlotButton(work_day_index) {
      const day = this.slot_config.work_days[work_day_index];

      if (!day.times.length) return false;

      const lastSlot = day.times[day.times.length - 1];

      return !lastSlot.start_time && !lastSlot.end_time;
    },
    buildSlotPayload() {
      const cleanTimes = times =>
        times.map(({ start_time, end_time }) => ({ start_time, end_time }));

      let payload = Object.assign({}, this.slot_config);

      if (payload.work_days.length == 1) {
        const cleanTimes0 = cleanTimes(payload.work_days[0].times);
        payload.work_days = [];
        this.work_days.filter((day, day_index) => {
          const day_of_week = this.getDayOfWeek(day_index);
          if (this.isInTheAppointmentDateInterval(day)) {
            payload.work_days.push({ day_of_week, times: cleanTimes0 });
          }
        });
      } else {
        payload.work_days = payload.work_days.map(work_day => ({
          day_of_week: work_day.day_of_week,
          times: cleanTimes(work_day.times)
        }));
      }

      return payload;
    },
    saveSlot() {
      swal.fire({
        title: "Confirmar!",
        text: "Deseja realizar o cadastro da sua agenda?",
        icon: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          let payload = this.buildSlotPayload();

          const scheduleDoctorId =
            this.$route.params && this.$route.params.doctorId
              ? this.$route.params.doctorId
              : null;

          const scheduleUnitId =
            this.$route.params && this.$route.params.unitId
              ? this.$route.params.unitId
              : null;

          payload.doctor_id = scheduleDoctorId;
          payload.unit_id = scheduleUnitId;

          return this.createSlot({ payload })
            .then(() => {
              swal
                .fire(
                  "Confirmado!",
                  "Sua agenda foi cadastrada com sucesso.",
                  "success"
                )
                .then(() => {
                  if (this.userGuide) {
                    this.$router.push({ name: "GuidePage" });
                  } else {
                    this.$router.push({ name: "Dashboard" });
                  }
                });
            })
            .catch(() => {
              swal.fire(
                "Opss!",
                "Erro no servidor, tente mais tarde.",
                "error"
              );
            });
        }
      });
    },
    photoFallback() {
      return (
        this.currentUser.photo ||
        require("./../../assets/images/doctor-img.jpg")
      );
    },
    openForm() {
      this.$store.commit("slot/SET_CREATING_SCHEDULE", true);
    },
    sortDayByDayOfWeek() {
      const sorting = (a, b) => {
        if (a.day_of_week < b.day_of_week) {
          return -1;
        }
        if (a.day_of_week > b.day_of_week) {
          return 1;
        }
        return 0;
      };

      return sorting;
    },
    sortedDays() {
      let days = Object.assign([], this.slot_config.work_days);

      return days.sort(this.sortDayByDayOfWeek());
    },
    noTranslateSomeWords() {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.target.querySelectorAll(".notranslate").forEach(element => {
            element.removeAttribute("translate");
          });
        });
      });
      observer.observe(this.$el, { childList: true, subtree: true });
    }
  },
  computed: {
    ...userComputed,
    disableDurationSelection() {
      return this.duration_type == 1;
    },
    renderMultipleDays() {
      return this.serviceHoursType == 1;
    },
    appointmentsDateInterval() {
      if (this.slot_config.from_date && this.slot_config.until_date)
        return eachDayOfInterval({
          start: parseISO(this.slot_config.from_date),
          end: parseISO(this.slot_config.until_date)
        });

      return [];
    },
    canSaveSlots() {
      let slotsFilled = false;

      this.slot_config.work_days.filter(day => {
        day.times.filter(slot => {
          if (slot.start_time && slot.end_time) slotsFilled = true;
        });
      });

      return (
        !this.slot_config.from_date ||
        !this.slot_config.until_date ||
        !this.slot_config.duration ||
        !slotsFilled
      );
    },
    dayIsSelectable() {
      return this.scheduleDaysCode != 3;
    },
    AllDaysSelected() {
      return this.serviceHoursType == 1;
    },
    dayByDaySelected() {
      return this.serviceHoursType == 2;
    },
    startOfAppointments() {
      return this.capitalizeFirstLetter(
        formatDate(this.slot_config.from_date, "PPPP")
      );
    },
    sortedDaysOnScheduleReview() {
      let arrayDaysSorted = Object.assign([], this.slot_config.work_days);
      return arrayDaysSorted.sort(this.sortDayByDayOfWeek());
    },
    selectedAndSortedDays() {
      let days = [];
      this.work_days.filter(work_day => {
        this.days.filter(day => {
          if (day.name === work_day)
            days.push({ work_day, day_of_week: day.day_of_week });
        });
      });
      return days.sort(this.sortDayByDayOfWeek());
    },
    userGuide() {
      return this.$store.state.auth.userGuide;
    },
    hasSlots() {
      return this.$store.state.slot.hasSlots;
    },
    creatingSchedule() {
      return this.$store.state.slot.creatingSchedule;
    },
    doctorId() {
      return this.$route.params && this.$route.params.doctorId
        ? this.$route.params.doctorId
        : this.currentUser.id;
    },
    unitId() {
      return this.$route.params && this.$route.params.unitId
        ? this.$route.params.unitId
        : "";
    },
    userIsReceptionist() {
      return isReceptionist(this.currentUser);
    }
  },
  watch: {
    scheduleDaysCode(newValue) {
      const defaultWorkdays = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday"
      ];
      if (newValue == 1) this.work_days = defaultWorkdays;
      if (newValue == 2)
        this.work_days = ["sunday", ...defaultWorkdays, "saturday"];
      if (newValue == 3) this.work_days = [];

      this.fillWorkDays();
    },
    duration_type(newValue) {
      if (newValue == 1) {
        this.slot_config.duration = 15;
      }
    },
    serviceHoursType(newValue) {
      if (newValue == 2 && this.slot_config.work_days.length == 1) {
        this.slot_config.work_days = [];
      }
      this.fillWorkDays();
    },
    work_days(newValue) {
      if (!newValue.length) this.slot_config.work_days = [];
      this.fillWorkDays();
    },
    "slot_config.duration"(newValue) {
      this.fillWorkDays();
    },
    "slot_config.from_date"(newValue) {
      this.fillWorkDays();
    },
    "slot_config.until_date"(newValue) {
      this.fillWorkDays();
    }
  }
};
</script>

<style src="./styles.css"></style>
